export function imgmoverinit() {

    let imgs = document.querySelector(".imgs"),
        imgsInner = document.querySelector(".imgs__inner"),
        imgsBlock = document.querySelector(".imgs__innerBlock"),
        figures = document.querySelectorAll(".imgs__innerBlock>figure"),
        colorStatus = false,
        snapable = true

    if (location.pathname == "/") {
        window.globalScrollY = 0
        window.onscroll = () => {
            imgMover()
        }
    } else {
        window.onscroll = null
    }

    function imgMover() {

        if (window.globalScrollY == null) {
            window.globalScrollY = window.scrollY
        }

        if (window.globalScrollY > window.innerHeight * 0.05 && snapable) {
            window.globalLocoScrollTo(document.querySelector(".imgs"), 750)
            snapable = false
        } else if (window.globalScrollY <= window.innerHeight * 0.05) {
            snapable = true
        }

        let imgsTop = document.querySelector(".imgs").offsetTop,
            imgsDeff = imgsBlock.clientWidth - window.innerWidth

        if (window.globalScrollY > imgsTop && !colorStatus) {
            window.globalColorInit()
            colorStatus = true
        }

        let imgsHeight = imgsBlock.clientWidth
        imgs.style.height = ((((imgsHeight / window.innerWidth * window.innerHeight) * (1 / (window.innerHeight / window.innerWidth)) - (window.innerWidth * (1 - (window.innerHeight / window.innerWidth))))) * 1.5) + "px"

        let imgsPercent = ((window.globalScrollY - imgsTop) / imgsDeff) / 1.5
        imgsInner.scroll(imgsDeff * imgsPercent, 0)
        // document.querySelector(".log").innerHTML = (Math.round(imgsDeff * imgsPercent) + " / " + imgsDeff + " = " + Math.round(imgsPercent * 100) / 100 + "<br>" + window.innerHeight / window.innerWidth)

        figures.forEach((fig, i) => {
            let figdata = fig.getBoundingClientRect()
            if ((figdata.left > 0 || figdata.right > 0) && (figdata.left <= window.innerWidth || figdata.right <= window.innerWidth)) {

                let figcenter = figdata.left + figdata.width / 2

                if (figdata.left + figdata.width * 0.33333 <= window.innerWidth) {
                    fig.classList.add("watched")
                }
                if (figcenter <= window.innerWidth * 0.7 && figcenter >= window.innerWidth * 0.3) {
                    fig.classList.add("watching")
                } else {
                    fig.classList.remove("watching")
                }
                let figpos = ((((figcenter)) / window.innerWidth) - 0.5) * -10
                fig.querySelector("img").style.transform = `translateX(${figpos}%)`

            }
        })
    }
}